import React from "react";
import Button from "devextreme-react/button";
import SelectBox from "devextreme-react/select-box";

const exportFormats = [
  { id: "PDF", name: "PDF" },
  { id: "EXCEL", name: "Excel" },
  { id: "CSV", name: "CSV" }
];

export default function ActionPanel({
  onPreview,
  onExecute,
  onExport,
  exportFormat,
  setExportFormat
}) {
  return (
    <div className="card action-card">
     

      <div className="action-row">

        {/* LEFT BUTTONS */}
        <div className="action-buttons">
        <h3>Actions</h3>
          <Button
            text="Preview"
            icon="search"
            stylingMode="contained"
            type="default"
            elementAttr={{ class: "btn-preview" }}
            onClick={onPreview}
          />

          <Button
            text="Execute"
            icon="runner"
            stylingMode="contained"
            type="success"
            elementAttr={{ class: "btn-execute" }}
            onClick={onExecute}
          />

          <Button
            text="Export"
            icon="export"
            stylingMode="outlined"
            elementAttr={{ class: "btn-export" }}
            onClick={onExport}
          />

        </div>

        {/* RIGHT DROPDOWN */}
        <div className="export-section">
          <label>Export File Type</label>

          <SelectBox
            items={exportFormats}
            valueExpr="id"
            displayExpr="name"
            value={exportFormat}
            onValueChanged={(e) => setExportFormat(e.value)}
            width={150}
          />
        </div>

      </div>
    </div>
  );
}